import { graphDefault, graphLabelText, graphValueText } from './';
export const graphDataText = (theme, parameters) => {
  const graphDefaultPattern = graphDefault(theme, parameters);
  const labelText = graphLabelText(theme, parameters);
  const valueText = graphValueText(theme, parameters);
  const common = {
    fontFamily: labelText.fontFamily,
    fontSize: graphDefaultPattern.fontSize.xxs,
    fontStyle: valueText.fontStyle,
    fontWeight: valueText.fontWeight
  };
  switch (theme.baseThemeName) {
    case 'dark':
      {
        return {
          ...common,
          textColor: labelText.textColor
        };
      }
    case 'high-contrast':
      {
        return {
          ...common,
          textColor: labelText.textColor
        };
      }
    default:
      {
        return {
          ...common,
          textColor: graphDefaultPattern.n_5
        };
      }
  }
};
//# sourceMappingURL=graphDataText.js.map